// eslint-disable-next-line import/extensions
import FormDuuf, {
  FormDuufField,
  FormDuufSubmit,
  FormDuufGroup,
  FormDuufProps,
  FieldProps as FormDuufFieldProps,
  FormDuufFieldData,
  prepareFormDuufField
} from './FormDuuf'
import FormDuufLabel from './elements/Label'
import FormDuufError from './elements/Error'
import useFormDuuf from './useFormDuuf'

export { FormDuufField, FormDuufSubmit, FormDuufGroup, FormDuufLabel, FormDuufError, useFormDuuf, prepareFormDuufField }
export type { FormDuufProps, FormDuufFieldProps, FormDuufFieldData }

export default FormDuuf
